import { useMemo } from "react";
import { useAuth } from "./useAuth";
import useApi from "./useApi";

const useOrganisations = (params = {}, opts = {}) => {
	const { user } = useAuth();
	const select = ["id", "name", "parent_id", "broker_id"].concat(
		user?.uwr ? ["paris_id"] : []
	);
	const { data, error, isLoading, mutate } = useApi(
		!params ? null : "organisations",
		{
			select,
			order: "name",
			...params,
		},
		{
			schema: user?.uwr ? "public" : "portal",
			...opts,
		}
	);

	const organisations = useMemo(() => {
		if (!data) return [];
		if (!user?.uwr) return data;
		let orgs = Array.isArray(data) ? data : [data];
		return orgs.map((org) => ({
			...org,
			long_name: `${org.name || ""}${org.paris_id ? ` [${org.paris_id}]` : ""}`, // used for "new application" select
		}));
	}, [data, user?.uwr]);

	return { organisations, error, isLoading, mutate };
};

export default useOrganisations;
